var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrap",staticClass:"image-wrap image-loader",class:{ error: _vm.error, noBg: _vm.noBg }},[_c('img',{ref:"image",style:({
      height: (_vm.height + "px"),
      width: (_vm.width + "px"),
      'margin-top': (_vm.marginTop + "px"),
      'margin-left': (_vm.marginLeft + "px")
    }),attrs:{"src":_vm.realSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }